<button
	pButton
	[label]="label"
	[disabled]="state"
	[icon]="icon"
	[class]="class"
	[ngClass]="{ spin: state && isAnimate }"
	class="ui-button"></button>
